"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CompanyInvoiceStatus;
(function (CompanyInvoiceStatus) {
    CompanyInvoiceStatus["all"] = "all";
    CompanyInvoiceStatus["paid"] = "paid";
    CompanyInvoiceStatus["open"] = "open";
    CompanyInvoiceStatus["past"] = "past";
    CompanyInvoiceStatus["allocreq"] = "allocreq";
    CompanyInvoiceStatus["pending"] = "pending";
    CompanyInvoiceStatus["cpaid"] = "cpaid";
    CompanyInvoiceStatus["received"] = "received";
    CompanyInvoiceStatus["voided"] = "voided";
})(CompanyInvoiceStatus = exports.CompanyInvoiceStatus || (exports.CompanyInvoiceStatus = {}));
//# sourceMappingURL=CompanyInvoiceStatus.js.map